
import { useSelector } from 'react-redux';
import { formatTimeAgo } from '../../utils/formattedDate';
import avatar from '../../assets/images/Avatar.png'
const NewMatch = ({ matchCreatedActivities }) => {

  return (
    <div className='recent-activity-section'>
      {matchCreatedActivities?.map((item, index) => {
        return (
          <div className='recent-activity-card' key={index}>
            <div className='recent-activity-avatar-image'>
              <img src={item?.user?.profilePicture} alt="avatar-image" />
            </div>
            <div className='recent-activity-data'>
              <div className=''>
                <div className='name'>{item?.user?.firstName} {item?.user?.lastName}</div>
                <span className={`type ${item?.user?.userType}`}>{item?.user?.userType}</span>
              </div>
              <div className='description'>{item?.activityDescription}</div>
              <div className='time'>{formatTimeAgo(item?.createdAt)}</div>
            </div>
          </div>
        )
      })}
    </div>
  )

}
export default NewMatch